export default __webpack_public_path__ + "static/logocdti-d33b2491f61b294ea3cf17cd6f1a4f6e.jpg";